import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { createContext } from "react"
import { useLocation } from "react-router-dom"

import { retry } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"

import HeaderContent from "./header-content"

const AccountMenu = loadable(() =>
  retry(() => import("./menu/mobile/account-menu"))
)
const MobileMenu = loadable(() =>
  retry(() => import("./menu/mobile/main-menu"))
)

export const HeaderMenuContext = createContext()

const Header = ({ menu }) => {
  const { isTablet, isLarge } = useWindowDimensions()
  const location = useLocation()

  if (
    location.pathname.includes("/checkout") ||
    location.pathname.includes("/payments")
  ) {
    return ""
  }

  return (
    <HeaderMenuContext.Provider value={{ menu }}>
      <HeaderContent />
      {isTablet && <AccountMenu />}
      {!isLarge && <MobileMenu />}
    </HeaderMenuContext.Provider>
  )
}

Header.propTypes = {
  menu: PropTypes.object,
}

export default Header
